import React, { useEffect, useState } from 'react';
import './DynamicLogo.css';

const DynamicLogo = () => {
    const [theme, setTheme] = useState<'summer' | 'winter' | 'christmas'>('summer');

    useEffect(() => {
        const today = new Date();
        const month = today.getMonth(); // 0-11

        // Logic xác định theme
        if (month === 11) { // Tháng 12
            setTheme('christmas');
        } else if (month >= 4 && month <= 9) { // Tháng 5 - Tháng 10
            setTheme('summer');
        } else { // Tháng 11 - Tháng 4 (trừ tháng 12 đã check)
            setTheme('winter');
        }
    }, []);

    return (
        <div className={`dynamic-logo-container ${theme}`}>
            <div className="logo-wrapper">
                <h1 className="app-cover-title dynamic-title">Phanh</h1>

                {/* Summer Elements */}
                {theme === 'summer' && (
                    <div className="sun-container">
                        <div className="sun"></div>
                        <div className="sun-rays"></div>
                    </div>
                )}

                {/* Winter Elements */}
                {theme === 'winter' && (
                    <div className="snow-container">
                        {[...Array(20)].map((_, i) => (
                            <div key={i} className="snowflake" style={{
                                left: `${Math.random() * 100}%`,
                                animationDelay: `${Math.random() * 5}s`,
                                animationDuration: `${5 + Math.random() * 10}s`
                            }}>❄</div>
                        ))}
                    </div>
                )}

                {/* Christmas Elements */}
                {theme === 'christmas' && (
                    <div className="christmas-container">
                        <div className="santa-hat">
                            <img src="https://assets.dryicons.com/uploads/icon/svg/6890/32d0c242-7c3d-4c57-827c-4a30a845920a.svg" alt="Santa Hat" />
                        </div>
                        <div className="flying-santa">
                            🎅🦌🦌
                        </div>
                        <div className="snow-container">
                            {[...Array(30)].map((_, i) => (
                                <div key={i} className="snowflake" style={{
                                    left: `${Math.random() * 100}%`,
                                    animationDelay: `${Math.random() * 3}s`
                                }}>❄</div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default DynamicLogo;
